import * as types from './question.types';
import * as constants from './question.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const questionReducer = generateResourceReducer<types.IQuestion>({
  STORE: constants.STORE_QUESTION,
  CLEAR: constants.CLEAR_QUESTION,
});
